// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3ikru","approved":"Status_approved__FfSzQ","rejected":"Status_rejected__L-5Cj","expired":"Status_expired__1XdP1","label":"Status_label__2p-Pm"};